var DiscView = Backbone.View.extend({

    initialize:function(params){
        var self = this;
        console.log("discView", params);
        this.dataApp = params.dataApp;
        this.hasRenderedNews = false;
        this.maxViewportSize = 0;
        this.zoom = 1;
        this.zoomScales = {
            1:1,
            2:1.3,
            3:1.6,
            4:1.9,
            5:2.2,
            6:2.5,
            7:2.8
        };
        this.$Disc = $("#App[data-app='"+this.dataApp+"'] #Disc");
        this.$legendToggler = $("#App[data-app='"+this.dataApp+"'] .legend_toggler");
        this.$DiscInner = $("#App[data-app='"+this.dataApp+"'] #DiscInner");
        this.$DiscTrends = $("#App[data-app='"+this.dataApp+"'] #DiscTrends");
        this.$DiscOverlay = $("#App[data-app='"+this.dataApp+"'] #DiscOverlay");
        this.$SidebarLogo = $("#App[data-app='"+this.dataApp+"'] #SidebarLogo");
        this.$News = $("#App[data-app='"+this.dataApp+"'] #News");
        this.$News2 = $("#App[data-app='"+this.dataApp+"'] #News2");
        this.$newsItems = $("#App[data-app='"+this.dataApp+"'] .news_items");
        this.$news2Items = $("#App[data-app='"+this.dataApp+"'] .news2_items");

        this.snapLinks = Snap("#App[data-app='"+this.dataApp+"'] #DiscLinks");

        this.nbPointsPerInnerDisc = 75;
        this.innerDiscs = {
            "act":{
                from:20, to:65, nb:20
            },
            "prepare":{
                from:77, to:85, nb:10
            },
            "watch":{
                from:92, to:100, nb:5
            }
        };

        this.fieldsParams = {
            "tech":{start:150, end:270},
            "business":{start:30, end:150},
            "society":{start:-90, end:30},
        };

        this.circleGradients = {
            "act_row1":{start:"#b4d22b", end:"#eb1701"},
            "act_row2":{start:"#b4d22b", end:"#eb1701"},
            "act_row3":{start:"#b4d22b", end:"#eb1701"},
            "prepare":{start:"#5ab7d9", end:"#754ead"},
            "watch":{start:"#3382b0", end:"#138df3"}
        }

        if(this.dataApp != "first"){
            this.circleGradients = {
                "act_row1":{start:"#F1BD30", end:"#eb1701"},
                "act_row2":{start:"#F1BD30", end:"#eb1701"},
                "act_row3":{start:"#F1BD30", end:"#eb1701"},
                "prepare":{start:"#F17F30", end:"#754ead"},
                "watch":{start:"#F14143", end:"#138df3"}
            }
        }
        

        this.maxActTrendsRow1 = 3;
        this.maxActTrendsRow2 = 11;
        this.nbFeatured = 0;

        this.gCircles = [];
        this.selectedView = "major";

        this.zIndexDecrement = 1000;
    },

    render:function(){
        this.renderDisc();
        this.hasRenderedNews = true;
        $("#App[data-app='"+this.dataApp+"'] .nbfeatured").html(this.nbFeatured);
        //$(".news_items").css("height", $(".news_items").height()+40);
        this.$News.removeClass("opacified");
        this.$News2.removeClass("opacified");

        this.renderNews2Items();
        this.bindEvents();
    },

    renderDisc:function(){
        var self = this;
        this.updateSize();
        var center = self.discSize/2;
        this.$DiscInner.empty();
        this.$DiscTrends.empty();

        if(this.discSize < 550) this.$Disc.attr("data-format", "vsmall");
        else if(this.discSize < 650) this.$Disc.attr("data-format", "small");
        else if(this.discSize < 750) this.$Disc.attr("data-format", "medium");
        else if(this.discSize < 850) this.$Disc.attr("data-format", "big");
        else this.$Disc.attr("data-format", "vbig");

        /*_.each(this.innerDiscs, function(discsCategory, index){
            var padding = (discsCategory.to - discsCategory.from) / discsCategory.nb;
            for(var i=0; i<discsCategory.nb ; i++){
                var innerdiscSizePct = i*padding + discsCategory.from;
                var innerdiscRadius = (self.discSize*(innerdiscSizePct/100)) / 2;
                
                var nbPoints = Math.floor((innerdiscRadius*36) / 51.5);
                //radius 51.5 -> nbPoints = 36 -> angleInc 10deg
                //radius 103 -> angleInc 5deg
                for(var k=0 ; k<nbPoints; k++){
                    var angle = (360/nbPoints)*k;
                    var radians = angle * Math.PI / 180;
                    var innerdiscX = center + innerdiscRadius*Math.cos(radians);
                    var innerdiscY = center + innerdiscRadius*Math.sin(radians);
                    var $innerdisc = $("<div class='innerdisc_point'></div>");
                    $innerdisc.attr("data-status", index)
                        .attr("data-angle", angle)
                        .css("left", innerdiscX)
                        .css("top", innerdiscY)
                        .attr("data-innerdiscRadius", innerdiscRadius);
                    self.$DiscInner.append($innerdisc);
                }
            }
        });*/

        this.renderTrendsBubbles();
    },

    updateSize:function(){
        if(App.appWidth > App.appHeight){
            this.maxViewportSize = App.appHeight;
        }else{
            this.maxViewportSize = App.appWidth;
        }

        this.discSize = this.maxViewportSize - 50;
        console.log("discSize", this.discSize);
        this.$Disc.css("width", this.discSize+"px")
                .css("height", this.discSize+"px");
    },

    renderTrendsBubbles:function(){
        var self = this;

        var fieldType = "fields";
        if(this.dataApp == "second") fieldType = "fieldsSecond";

        _.each(App.utils[fieldType], function(fieldData, fieldID){
            var statusesTrends = {
                "act":_.filter(fieldData, function(fd){ return fd.status == "act"; }),
                "prepare":_.filter(fieldData, function(fd){ return fd.status == "prepare"; }),
                "watch":_.filter(fieldData, function(fd){ return fd.status == "watch"; })
            };
            _.each(statusesTrends, function(statusTrends, statusID){
                if(statusID == "act"){
                    self.updateActTrendsBubbles(fieldID, statusID, statusTrends);
                }else{
                    self.updatePolarRow(fieldID, statusID, statusTrends);
                }
                
            })
        });
    },

    updateActTrendsBubbles:function(fieldID, statusID, statusTrends){
        var self = this;
        var sortedTrends = _.sortBy(statusTrends, function(t){ return t.size; });
        var actTrendsRow1 = [];
        var actTrendsRow2 = [];
        var actTrendsRow3 = [];

        _.each(sortedTrends, function(trend, inc){
            if((inc+1) <= self.maxActTrendsRow1){
                actTrendsRow1.push(trend);
            }else if((inc+1) <= self.maxActTrendsRow2){
                actTrendsRow2.push(trend);
            }else{
                actTrendsRow3.push(trend);
            }
        });

        this.updatePolarRow(fieldID, "act_row1", actTrendsRow1);
        this.updatePolarRow(fieldID, "act_row2", actTrendsRow2);
        this.updatePolarRow(fieldID, "act_row3", actTrendsRow3);
    },

    updatePolarRow:function(fieldID, polarRowID, trends){
        var self = this;
        var polarRowInc = 0;
        var polarRowRadius = 0;
        var center = self.discSize/2;

        switch(polarRowID){
            case "act_row1":
                var actRadiusSize = self.innerDiscs.act.to - self.innerDiscs.act.from;
                //var firstActRadiusPct = ((self.innerDiscs.act.from + (actRadiusSize/3)))/100;
                firstActRadiusPct = (self.innerDiscs.act.from+13)/100;
                polarRowRadius = (firstActRadiusPct * self.discSize) / 2;
                polarRowInc = ((this.fieldsParams[fieldID].end - this.fieldsParams[fieldID].start)+30) / (trends.length+1);
            break;
            case "act_row2":
                var actRadiusSize = self.innerDiscs.act.to - self.innerDiscs.act.from;
                var secondActRadiusPct = ((self.innerDiscs.act.from+2 + ((actRadiusSize/3)*1.8)))/100;
                polarRowRadius = (secondActRadiusPct * self.discSize) / 2;
                polarRowInc = (this.fieldsParams[fieldID].end - this.fieldsParams[fieldID].start) / (trends.length + 1);
            break;
            case "act_row3":
                var actRadiusSize = self.innerDiscs.act.to - self.innerDiscs.act.from;
                var thirdActRadiusPct = ((self.innerDiscs.act.from+2 + ((actRadiusSize/3)*2.8)))/100;
                polarRowRadius = (thirdActRadiusPct * self.discSize) / 2;
                polarRowInc = (this.fieldsParams[fieldID].end - this.fieldsParams[fieldID].start) / (trends.length + 1);
            break;
            case "prepare":
                var prepareRadiusSize = self.innerDiscs.prepare.to - self.innerDiscs.prepare.from;
                var prepareRadiusPct = (self.innerDiscs.prepare.from + (prepareRadiusSize/2)) / 100;
                polarRowRadius = (prepareRadiusPct * self.discSize) / 2;
                polarRowInc = (this.fieldsParams[fieldID].end - this.fieldsParams[fieldID].start) / (trends.length + 1);
            break;
            case "watch":
                var watchRadiusSize = self.innerDiscs.watch.to - self.innerDiscs.watch.from;
                var watchRadiusPct = (self.innerDiscs.watch.from + (watchRadiusSize/2)) / 100;
                polarRowRadius = (watchRadiusPct * self.discSize) / 2;
                polarRowInc = (this.fieldsParams[fieldID].end - this.fieldsParams[fieldID].start) / (trends.length + 1);
            break;
        }

        var alphaTrends = App.utils.reorganizeTrends(trends, polarRowID);

        if(this.dataApp == "first") App.utils.polarTrends[fieldID+"-"+polarRowID] = alphaTrends;
        else if(this.dataApp == "second") App.utils.polarTrendsSecond[fieldID+"-"+polarRowID] = alphaTrends;

        _.each(alphaTrends, function(trend, inc){
            var angle = self.fieldsParams[fieldID].start + polarRowInc*(inc+1);
            if(polarRowID == "act_row1") angle = (self.fieldsParams[fieldID].start-15) + polarRowInc*(inc+1);
            
            var radians = angle * Math.PI / 180;
            trendCircleX = center + polarRowRadius*Math.cos(radians);
            trendCircleY = center + polarRowRadius*Math.sin(radians);

            var $trendCircle = $("<div class='trend_circle'><div class='circle_touchtapfordetails'>Tap for details</div></div>");


            var circleSize = ((App.utils.sizeRadiuses[trend.size] * (self.discSize/App.utils.discSizeRef)) * 2);

            /*
            if( (inc%2 == 1) && (polarRowID == "act_row2" || polarRowID == "act_row3")) {
                circleSize = ((App.utils.sizeRadiuses["medium2"] * (self.discSize/App.utils.discSizeRef)) * 2);
                console.log("ici if", circleSize);
            }
            */

            circleSize = 2 * Math.round(circleSize / 2);
            $trendCircle.css("left", trendCircleX)
                        .css("top", trendCircleY)
                        .css("width", circleSize)
                        .css("height", circleSize)
                        .css("background", self.circleGradients[polarRowID].start)
                        .attr("data-status", trend.status)
                        .attr("data-trend", trend.slugTrend)
                        .attr("data-id", trend.id)
                        .attr("data-level", trend.level)
                        .attr("data-featured", trend.featured)
                        .attr("data-field", trend.field)
                        .attr("data-size", trend.size)
                        .attr("data-polar", polarRowID)
                        .attr("data-origin-size", circleSize)
                        .attr("data-origin-left", trendCircleX)
                        .attr("data-origin-top", trendCircleY)
                        .css("z-index", self.zIndexDecrement);

            if(self.dataApp == "first") App.utils.trends[trend.id].polar = polarRowID;
            else if(self.dataApp == "second") App.utils.trendsSecond[trend.id].polar = polarRowID;
            //var trendText = self.snapContainer.text(trendCircleX,trendCircleY, trend.trend);
            var minwidthed = "";
            if(trend.trend.length > 20){
                minwidthed = "minwidthed";
            }
            var shortText = trend.trend;
            if(trend.short_label !== '') shortText = trend.short_label;

            var $trendText = $("<div class='circle_text "+minwidthed+"'><span class='text_span'>"+trend.trend+"</span><span class='textsmall_span'>"+shortText+"</span></div>");
            $trendCircle.append($trendText);

            var textPos = "outText"
            if(trend.size == "big"){
                textPos = "inText";
            }
            textPos = "inText";
            
            $trendCircle.addClass(textPos);

            self.$DiscTrends.append($trendCircle);

            if(trend.featured == "1" && !self.hasRenderedNews){
                self.nbFeatured += 1;
                self.appendNewsItem(trend);
            }

            self.zIndexDecrement += 1;
        });
    },

    appendNewsItem:function(trend){
        /*var itemText = "<div class='text_title'>[TREND]</div> is a [FIELD] [LEVEL] to [STATUS], updated this week";

        itemText = itemText.replace("[TREND]", trend.trend);
        itemText = itemText.replace("[FIELD]", trend.field);

        strLevel = "detailed trend";
        if(trend.level == "first") strLevel = "major trend";
        itemText = itemText.replace("[LEVEL]", strLevel);

        strStatus = "watch";
        if(trend.status == "act") strStatus = "act on";
        if(trend.status == "prepare") strStatus = "prepare for";
        itemText = itemText.replace("[STATUS]", strStatus);*/

        //<div class='text_other' data-field='"+trend.field+"'>"+App.utils.fieldsData[trend.field].label+"</div>
        var statusStr = trend.status;

        /*var prunedText = trend.featured_text;
        var isdetail = "";
        if(trend.featured_text.length > 70){
            prunedText = _.str.prune(trend.featured_text, 70, "");
            prunedText += " <a class='details_morebt'>more...</a>";
            isdetail = "isdetail";
        }
        console.log("prunedText", prunedText);*/
        var statusLabel = App.utils.statusesLabel[statusStr];
        var $newsItem = $("<div class='news_item' data-trend='"+trend.id+"'><div class='item_field'>"+statusLabel+"</div><div class='item_text'><div class='text_title'>"+trend.trend+"</div><div class='text_details'>"+trend.featured_text+" <a class='details_morebt'>Plus</a></div></div></div>");
        $newsItem.attr("data-status", trend.status)
                .attr("data-field", trend.field);

        this.$newsItems.append($newsItem);
    },

    renderNews2Items: function () {
        var self = this;
        var radarsData = App.utils.radars;
        if(this.dataApp == "second") radarsData = App.utils.radarsSecond;

        _.each(radarsData, function (postObj){
            var $news2Item = $("<div class='news_item'><div class='item_text'><a class='text_title' href='"+postObj.meta_value+"' target='_blank'>"+postObj.post_title+"</a></div></div>");
            self.$news2Items.append($news2Item);
        })  
    },

    update:function(){
        this.$Disc.attr("data-view", this.selectedView);
        this.$legendToggler.attr("data-view", this.selectedView);
    },

    mask:function(){
        console.log("mask", this.dataApp);
        $("#App[data-app='"+this.dataApp+"'] .trend_circle.tobemasked").addClass("masked");
        this.$DiscInner.addClass("masked");
        $("#App[data-app='"+this.dataApp+"'] .discoverlay").addClass("masked");
        $("#App[data-app='"+this.dataApp+"'] #ZoomBlock").addClass("notdisplayed");
        $("#App[data-app='"+this.dataApp+"'] #GlobalForcesBt").removeClass("disopacified");
        $("#App[data-app='"+this.dataApp+"'] #News").addClass("notdisplayed");
        $("#App[data-app='"+this.dataApp+"'] #News2").addClass("notdisplayed");
        $("#App[data-app='"+this.dataApp+"'] #ActionsLegend").addClass("notdisplayed");
    },

    unmask:function(){
        console.log("unmask", this.dataApp);
        $("#App[data-app='"+this.dataApp+"'] .trend_circle.masked").removeClass("masked");
        this.$DiscInner.removeClass("masked");
        $("#App[data-app='"+this.dataApp+"'] .discoverlay").removeClass("masked");
        $("#App[data-app='"+this.dataApp+"'] #ZoomBlock").removeClass("notdisplayed");
        $("#App[data-app='"+this.dataApp+"'] #GlobalForcesBt").addClass("disopacified");
        $("#App[data-app='"+this.dataApp+"'] #News").removeClass("notdisplayed");
        $("#App[data-app='"+this.dataApp+"'] #News2").removeClass("notdisplayed");
        $("#App[data-app='"+this.dataApp+"'] #ActionsLegend").removeClass("notdisplayed");
    },

    bindEvents:function(){
        var self = this;

        this.$DiscTrends.on("mouseenter", ".trend_circle", function(){
            self.hoverCircle($(this));
        });

        this.$DiscTrends.on("mouseleave", ".trend_circle", function(){
            if((App.currentPage == "disc" || App.currentPage == "disc2") && App.isClickable){
                $("#App[data-app='"+this.dataApp+"'] .trend_circle").removeClass("firstclicked");
                self.leaveTrend();    
            }
        });

        this.$DiscTrends.on("click", ".trend_circle", function(){
            if(App.isClickable){
                var $circle = $(this);
                /*if($circle.hasClass("firstclicked")){
                    $(".trend_circle").removeClass("firstclicked");
                    self.removeTrendLinks();
                    App.selectTrend($circle.attr("data-id"));
                }else{
                    $(".trend_circle").removeClass("firstclicked");
                    $circle.addClass("firstclicked");
                    self.hoverCircle($circle);
                }*/
                $("#App[data-app='"+this.dataApp+"'] .trend_circle").removeClass("firstclicked");
                self.removeTrendLinks();
                App.selectTrend($circle.attr("data-id"));
            }
        });

        $("#App[data-app='"+this.dataApp+"'] .zoom_plus").on("click", function(){
            self.zoomIn();
        });

        $("#App[data-app='"+this.dataApp+"'] .zoom_less").on("click", function(){
            self.zoomOut();
        });

        $("#App[data-app='"+this.dataApp+"'] .zoom_zero").on("click", function(){
            self.zoomZero();
        });

        this.$Disc.on("dblclick", function(){
            self.zoomIn();
        });

        this.$Disc.draggable({});

        $("#App[data-app='"+this.dataApp+"'] #News .news_title").on("click", function(){
            self.$News.toggleClass("shrinked");
            self.$News2.addClass("shrinked");
            self.$SidebarLogo.removeClass("textdisplayed");
            self.$Disc.attr("data-hasnonews", self.$News.hasClass("shrinked"));
            $(".news_items").css("max-height", (window.innerHeight - 500) + "px");
        });

        $("#App[data-app='"+this.dataApp+"'] #News2 .news_title").on("click", function(){
            self.$News2.toggleClass("shrinked");
            self.$News.addClass("shrinked");
            self.$SidebarLogo.removeClass("textdisplayed");
            $(".news2_items").css("max-height", (window.innerHeight - 500) + "px");
        });

        $("#App[data-app='"+this.dataApp+"'] .toggler_toggle").on("click", function(){
            self.toggleView();
        });


        var sourceAutocomplete = App.utils.autocompleteTrends;
        if(this.dataApp == "second") sourceAutocomplete = App.utils.autocompleteTrendsSecond;
        $( "#App[data-app='"+this.dataApp+"'] #SearchInput" ).autocomplete({
          minLength: 0,
          position:{ my: "left top", at: "left bottom", collision: "none" },
          source: sourceAutocomplete,
          focus: function( event, ui ) {
            $("#App[data-app='"+this.dataApp+"'] #SearchInput").val(ui.item.label);
            return false;
          },
          select: function( event, ui ) {
            $("#App[data-app='"+this.dataApp+"'] #SearchInput").val(ui.item.label);
            App.selectTrend(ui.item.value);
            return false;
          }
        })
        .focus(function () {
            $(this).autocomplete("search");
        })
        .autocomplete( "instance" )._renderItem = function( ul, item ) {
          /*return $( "<li>" )
            .append( "<div>" + item.label + "<br>" + item.desc + "</div>" )
            .appendTo( ul );*/

            // Replace the matched text with a custom span. This
            // span uses the class found in the "highlightClass" option.
            var re = new RegExp( "(" + this.term + ")", "gi" ),
                cls = "highlight",
                template = "<span class='" + cls + "'>$1</span>",
                label = item.label.replace( re, template ),
                $li = $( "<li/>" ).appendTo( ul );

            // Create and return the custom menu item content.
            $( "<div/>" ).html( label ).appendTo( $li );

            return $li;
        };

        $("#App[data-app='"+this.dataApp+"'] #News").on("click", ".news_item", function(){
            self.removeTrendLinks();
            App.selectTrend($(this).attr("data-trend"));
        });
    },

    toggleMoreNewsItem:function($newsItem){
        var trendID = $newsItem.attr("data-trend");
        var trendData = App.utils.trends[trendID];
        if(this.dataApp == "second") trendData = App.utils.trendsSecond[trendID];
        if($newsItem.hasClass("expanded")){
            var prunedText = _.str.prune(trendData.featured_text, 70, "");
            prunedText += " <a class='details_morebt'>more...</a>";
            $newsItem.find(".text_details").html(prunedText);
            $newsItem.removeClass("expanded");
        }else{
            $newsItem.addClass("expanded");
            $newsItem.find(".text_details").html(trendData.featured_text);
        }
    },

    hoverCircle:function($circle){
        var self = this;
        console.log("hoverCircle", $circle);
        if(App.isClickable){
            var dataID = $circle.attr("data-id");
            if(App.utils.isTouchDevice()){
                $circle.addClass("touchtapfordetails");
                self.displayTrendLinks(dataID, true);
            }else{
                self.displayTrendLinks(dataID, true);
            }
        }
    },

    displayTrendLinks:function(trendID, isBezier){
        var self = this;

        this.removeTrendLinks();
        $("#App[data-app='"+this.dataApp+"'] .trend_circle").addClass("unhovered")
                        .removeClass("hovered")
                        .removeClass("linked");

        var discPosition = {
            left:this.$Disc[0].getBoundingClientRect().left,
            top:this.$Disc[0].getBoundingClientRect().top,
            scale:this.zoomScales[this.zoom]
        };

        var $root = $("#App[data-app='"+this.dataApp+"'] .trend_circle[data-id='"+trendID+"']");
        $root.removeClass("unhovered")
            .addClass("hovered");

        var rootBounds = $root[0].getBoundingClientRect();
        var rootPosition = {
            left:rootBounds.left + (rootBounds.width/2) - (discPosition.left),
            top:rootBounds.top + (rootBounds.width/2) - (discPosition.top),
        };

        var links = [];

        var trendType = "trends";
        if(this.dataApp == "second") trendType = "trendsSecond";

        _.each(App.utils[trendType][trendID].links, function(linkedTrend){
            var $linkedTrend = $("#App[data-app='"+self.dataApp+"'] .trend_circle[data-trend='"+linkedTrend+"']");

            var linkedID = $linkedTrend.attr("data-id");
            $linkedTrend.addClass("linked");
            if($linkedTrend.length > 0){
                var linkedBounds = $linkedTrend[0].getBoundingClientRect();
                //alert(JSON.stringify(linkedBounds));
                var linkedPosition = {
                    left:linkedBounds.left + (linkedBounds.width/2) - (discPosition.left),
                    top:linkedBounds.top + (linkedBounds.height/2) - (discPosition.top)
                }
                if(rootPosition.left == linkedPosition.left) linkedPosition.left += 1;
                if(rootPosition.top == linkedPosition.top) linkedPosition.top += 1;
                var pathLink = self.getPathLink(rootPosition, linkedPosition, discPosition, isBezier);
                var p = self.snapLinks.path(pathLink).attr({
                    fill: "none",
                    stroke: "#333",
                    strokeWidth: 3,
                });

                var way = "right";
                if(rootPosition.left > linkedPosition.left) way = "left";
                
                var dataAppStroke = "";
                if(self.dataApp == "second") dataAppStroke = "2";

                p.attr("stroke", "url(#"+App.utils[trendType][trendID].status+"-"+App.utils[trendType][linkedID].status+"-"+way+""+dataAppStroke+")");
                console.log("strokeURL", "url(#"+App.utils[trendType][trendID].status+"-"+App.utils[trendType][linkedID].status+"-"+way+""+dataAppStroke+")")
                p.attr("class", "trend_link");
                p.attr("data-origin", App.utils[trendType][trendID].status);
                p.attr("data-dest", App.utils[trendType][linkedID].status);
                p.attr("data-way", way);
                p.attr("data-origin-trend", trendID);
                p.attr("data-dest-trend", linkedID);

                if(!App.utils.isTouchDevice()){
                    p.attr("strokeDasharray", p.getTotalLength());
                    p.attr("strokeDashoffset", p.getTotalLength());
                    links.push(p);
                }
            }
        });

        if(!App.utils.isTouchDevice()){
            _.each(links, function(link){
                link.animate({strokeDashoffset:0}, 600, mina.linear);
            });
        }

        
    },

    getPathLink:function(rootPosition, linkedPosition, discPosition, isBezier){
        var originPoint = {
            x:(rootPosition.left/discPosition.scale),
            y:(rootPosition.top/discPosition.scale)
        };

        var destPoint = {
            x:(linkedPosition.left/discPosition.scale),
            y:(linkedPosition.top/discPosition.scale)
        };

        var qPoint = {x:0, y:0, shiftX:0, shiftY:0};
        if(originPoint.x > destPoint.x){
            qPoint.x = originPoint.x - ((originPoint.x - destPoint.x) / 2);
            qPoint.shiftY = (originPoint.x - destPoint.x) / 2;
        }
        else{
            qPoint.x = originPoint.x + ((destPoint.x - originPoint.x) / 2);
            qPoint.shiftY = (destPoint.x - originPoint.x) / 2;
        }

        if(originPoint.y > destPoint.y){
            qPoint.y = originPoint.y - ((originPoint.y - destPoint.y) / 2);
            qPoint.shiftX = (originPoint.y - destPoint.y) / 2;
        }
        else{
            qPoint.y = originPoint.y + ((destPoint.y - originPoint.y) / 2);
            qPoint.shiftX = (destPoint.y - originPoint.y) / 2;
        }

        //
        //console.log("M" + originPoint.x + " " + originPoint.y + " Q " + qPoint.x + " " + qPoint.y + " " + destPoint.x + " " + destPoint.y);
        if(true) return "M" + originPoint.x + " " + originPoint.y + " Q " + (qPoint.x + qPoint.shiftX) + " " + (qPoint.y + qPoint.shiftY) + " " + destPoint.x + " " + destPoint.y;
        else return "M"+originPoint.x+","+originPoint.y+"L"+destPoint.x+","+destPoint.y;

    },

    removeTrendLinks:function(){
        $("#App[data-app='"+this.dataApp+"'] .trend_link").remove();
    },

    leaveTrend:function(){
        $("#App[data-app='"+this.dataApp+"'] .trend_circle").removeClass("unhovered")
                        .removeClass("hovered")
                        .removeClass("linked")
                        .removeClass("touchtapfordetails");
        this.removeTrendLinks();
    },

    zoomZero:function(){
        $("#App[data-app='"+this.dataApp+"'] #DiscMetaWrapper").attr("data-zoom", "1");
        this.$Disc.css("left", "0px")
                    .css("top", "0px")
                    .removeClass("introtranslated");
        this.zoom = 1;
    },

    zoomIn:function(){
        this.zoom += 1;
        $("#App[data-app='"+this.dataApp+"'] #DiscMetaWrapper").attr("data-zoom", this.zoom);
    },

    zoomOut:function(){
        this.zoom -= 1;
        $("#App[data-app='"+this.dataApp+"'] #DiscMetaWrapper").attr("data-zoom", this.zoom);
                /*.css("left", "0px")
                .css("top", "0px");*/
        if(this.zoom == 1){
            this.$Disc.removeClass("introtranslated");
        }
    },

    toggleView:function(){
        if(this.selectedView == "major") this.selectedView = "all";
        else this.selectedView = "major";

        App.update();
    }

});

module.exports = DiscView;